import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P55-E1",
    audio: "img/FriendsPlus/Page54/Audio/audio-e3-p54.mp3",
    video: "Videos/e3.p54.mp4",
    component: UI,
    recorder: true,
    question: [],
    titleQuestion: [{ color: "#44509f", num: "1", title: 'Listen to the story and repeat. Act.' }],
    questionImage: [
      // Row
      [{ url: "img/FriendsPlus/Page54/E3/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page54/E3/5.jpg" },
        { url: "img/FriendsPlus/Page54/E3/6.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh1-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/7.jpg" },
        { url: "img/FriendsPlus/Page54/E3/8.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh2-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/9.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page54/E3/10.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page54/E3/11.jpg" },
        { url: "img/FriendsPlus/Page54/E3/12.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh3-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/13.jpg" },
        { url: "img/FriendsPlus/Page54/E3/14.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh4-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/15.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page54/E3/16.jpg" }],
      [
        // Column5
        { url: "img/FriendsPlus/Page54/E3/17.jpg" },
        { url: "img/FriendsPlus/Page54/E3/18.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh5-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/19.jpg" },
        { url: "img/FriendsPlus/Page54/E3/20.jpg", audioUrl: "img/FriendsPlus/Page54/Audio/hinh6-e3-p54.mp3", },
        { url: "img/FriendsPlus/Page54/E3/21.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page54/E3/22.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P55-E2",
    audio: "img/FriendsPlus/Page55/Audio/audio-e2-p55.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page55/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/tieude-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page55/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page55/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh1-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/7.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh2-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/9.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/10.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh3-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/11.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/12.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh4-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/13.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page55/E2/14.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/15.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh1-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/16.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/17.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh2-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/18.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/19.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh3-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/20.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/21.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh4-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/22.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page55/E2/23.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/24.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh1-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/25.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/26.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh3-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/27.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/28.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh4-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/29.jpg" },
      ],
      [
        // Column2
        { url: "img/FriendsPlus/Page55/E2/30.jpg" },
        {
          url: "img/FriendsPlus/Page55/E2/31.jpg",
          audioUrl: "img/FriendsPlus/Page55/Audio/hinh1-e2-p55.mp3",
        },
        { url: "img/FriendsPlus/Page55/E2/32.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page55/E2/33.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P55-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page55/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P55-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page55/E4/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    // titleQuestion: [{ color: "#44509f", num: "4", title: 'Look again and write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <img src="img/FriendsPlus/Page55/E4/title.jpg" style="width: 100%">
            <div><b>1</b>&ensp;<u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;Open&ensp;</u> the window.</div>
            <div><b>2</b># your coat.</div>
            <div><b>3</b># the window.</div>
            <div><b>4</b># your hat.</div>
          </div>
        `,
        answer: ["Don't put on", "Don't open", "Put on"],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 8",
    id: "SB3-U8-P55-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page55/E5/1.jpg" }]],
  },
};

export default json;
